export const aciSafetyBox = {
    iconName: 'safety-box',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2.268 6.731c0-.956.775-1.731 1.73-1.731h16.004c.956 0 1.731.775 1.731 1.731v12.31c0 .957-.775 1.732-1.73 1.732H3.998a1.731 1.731 0 01-1.731-1.731V6.73zM3.998 6a.731.731 0 00-.73.731v12.31c0 .404.327.732.73.732h16.004a.731.731 0 00.731-.731V6.73a.731.731 0 00-.73-.731H3.998z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.96 9.192c0-.956.776-1.731 1.732-1.731h9.848c.956 0 1.732.775 1.732 1.731v7.386c0 .956-.776 1.731-1.732 1.731H7.692a1.731 1.731 0 01-1.731-1.73V9.191zm1.732-.731a.731.731 0 00-.731.731v7.386c0 .404.327.731.731.731h9.848a.731.731 0 00.732-.73V9.191a.731.731 0 00-.732-.731H7.692z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.113 11.04a.5.5 0 01.5-.5h3.693a.5.5 0 110 1H4.613a.5.5 0 01-.5-.5zM4.113 14.734a.5.5 0 01.5-.5h3.693a.5.5 0 110 1H4.613a.5.5 0 01-.5-.5zM13.538 14.617a.192.192 0 100-.384v-.616a.808.808 0 100 1.616v-.616z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.54 13.617a.808.808 0 110 1.616v-.616a.192.192 0 110-.384v-.616zM13.538 11.54a.192.192 0 000-.385v-.616a.808.808 0 100 1.616v-.616zM6.153 13.617a.808.808 0 110 1.616v-.616a.192.192 0 010-.384v-.616z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.54 10.54a.808.808 0 110 1.615v-.616a.192.192 0 010-.384v-.616zM16.001 11.54a.192.192 0 000-.385v-.616a.808.808 0 100 1.616v-.616z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16 10.54a.808.808 0 110 1.615v-.616a.192.192 0 010-.384v-.616zM16.001 14.617a.192.192 0 100-.384v-.616a.808.808 0 100 1.616v-.616z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16 13.617a.808.808 0 110 1.616v-.616a.192.192 0 010-.384v-.616z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
